<template>
  <MainLayout>
    <Transition appear>
      <div
        style="display: flex; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.5)"
      >
        <div style="margin: auto; color: white">
          <div class="loader">Loading</div>
          <div>Please wait for a moment</div>
        </div>
      </div>
    </Transition>
  </MainLayout>
</template>

<script>
export default {
  metaInfo: {
    title: "Loading",
    meta: [{ name: "description", content: "Loading page" }]
  }
};
</script>

<style scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 3.75em auto;
  font-size: 0.625em;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid white;
  border-right: 1.1em solid white;
  border-bottom: 1.1em solid white;
  border-left: 1.1em solid var(--primary);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
